import { get, put } from 'utils/apiClient';
import React, { createContext, useState } from 'react';

const ConfigContext = createContext();

function Provider({ children }) {
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(false)
    // const [configTypes, setConfigTypes] = useState([])
    const [configData, setConfigData] = useState(null)
    const [rawConfigData, setRawConfigData] = useState(null)
    const [parseError, setParseError] = useState(false)
    const [updateResponse, setUpdateResponse] = useState()

    const configMetadata = {
        'POST_APPT_CONFIRM_FF': {
            displayName: 'Post Appointment Confirmation Validation Config',
            fields: [
                {
                    displayName: 'Customer Id',
                    internalName: 'ord_cust_id',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'Appt System',
                    internalName: 'appt_sys_ref',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'Location',
                    internalName: 'm_loc_id',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'Seg Alloc Code',
                    internalName: '(ext_attrbs or {}).get(\'tms_additional_attribs\', {}).get(\'segAllocCode\')',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                }
            ]
        },
        'APPT_REQ_ORD_PROC_CFG': {
            displayName: 'Pending Approval Config',
            fields: [
                {
                    displayName: 'Customer ID',
                    internalName: 'customerId',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'TMS Location ID',
                    internalName: 'locationId',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'Stop Type',
                    internalName: 'stopType',
                    type: 'string',
                    inputType: 'dropdown',
                    validValues: ['PICK', 'DROP'],
                    userCanEnter: 'One',
                    isMultiple: false
                },
                {
                    displayName: 'Revenue Code',
                    internalName: 'orderRevenueCode',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'Customer Category',
                    internalName: 'tms_additional_attribs.get(\'customerCategory\')',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'Address',
                    internalName: 'address',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'City',
                    internalName: 'city',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'State',
                    internalName: 'state',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'Appointment System ID',
                    internalName: 'appt_system_id',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'Equipment Type',
                    internalName: 'equipmentType',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'Seg Alloc Code',
                    internalName: 'tms_additional_attribs.get(\'segAllocCode\')',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                }
            ]
        },
        'LOC_MAPPING_RULES': {
            displayName: 'Location Mapping Rules',
            fields: [
                {
                    displayName: 'Location ID',
                    internalName: 'locationId',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'Customer ID',
                    internalName: 'customerId',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'Address',
                    internalName: 'address',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'City',
                    internalName: 'city',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'State',
                    internalName: 'state',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                },
                {
                    displayName: 'Temperature Max',
                    internalName: 'temperature_max',
                    type: 'integer',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One',
                    isMultiple: false
                },
                {
                    displayName: 'Temperature Min',
                    internalName: 'temperature_min',
                    type: 'integer',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One',
                    isMultiple: false
                },
                {
                    displayName: 'Stop Type',
                    internalName: 'stopType',
                    type: 'string',
                    inputType: 'dropdown',
                    validValues: ['PICK', 'DROP'],
                    userCanEnter: 'One',
                    isMultiple: false
                },
                {
                    displayName: 'Seg Alloc Code',
                    internalName: 'tms_additional_attribs.get(\'segAllocCode\')',
                    type: 'string',
                    inputType: 'text',
                    validValues: 'Free form',
                    userCanEnter: 'One or more',
                    isMultiple: true
                }
            ]
        }
    }

    const getOperatorsByFieldType = (fieldType, isMultiple = false) => {
        const operatorsByType = {
            string: [
                { value: '=', label: 'Equals' },
                { value: '=ignore_case', label: 'Equals (Ignore Case)' },
                { value: '!=', label: 'Not Equals' },
                { value: 'starts_with', label: 'Starts With' },
                { value: 'ends_with', label: 'Ends With' },
                { value: 'contains', label: 'Contains' }
            ],
            integer: [
                { value: '=', label: 'Equals' },
                { value: '!=', label: 'Not Equals' },
                { value: '>', label: 'Greater Than' },
                { value: '<', label: 'Less Than' },
                { value: '>=', label: 'Greater Than or Equal' },
                { value: '<=', label: 'Less Than or Equal' }
            ]
        }
        let operators = operatorsByType[fieldType] || operatorsByType.string
        if (isMultiple) {
            operators = [{ value: 'in', label: 'In' }, ...operators]
        }
        return operators
    }

    const getConfigMetadata = (configType) => {
        return configMetadata[configType] || null
    }

    const getFieldMappings = (configType) => {
        const metadata = getConfigMetadata(configType)
        if (!metadata) return {}
        
        const mappings = {}
        metadata.fields.forEach(field => {
            mappings[field.displayName] = field.internalName
        })
        return mappings
    }

    const getFieldOptions = (configType) => {
        const metadata = getConfigMetadata(configType)
        if (!metadata) return []
        
        return metadata.fields.map(field => field.displayName)
    }

    const getOperatorsForField = (configType, fieldDisplayName) => {
        const metadata = getConfigMetadata(configType)
        if (!metadata) return []
        
        const field = metadata.fields.find(f => f.displayName === fieldDisplayName)
        if (!field) return []
        return getOperatorsByFieldType(field.type, field.isMultiple)
    }

    // const loadConfigTypes = async () => {
    //     setLoading(true)
    //     try {
    //         setConfigTypes(['POST_APPT_CONFIRM_FF', 'APPT_REQ_ORD_PROC_CFG'])
    //         setLoading(false)
    //     } catch (error) {
    //         console.error('Load config types error:', error);
    //         setLoading(false)
    //         setError(true)
    //     }
    // }

    const getDefaultVarsForConfigType = (configType) => {
        const defaults = {
            'APPT_REQ_ORD_PROC_CFG': [
                {
                    name: 'ignore_pending_update',
                    type: 'LIT',
                    notes: 'Ignore Pending Update',
                    value: 'False'
                },
                {
                    name: 'ignore_pending_update_notif',
                    type: 'LIT',
                    notes: 'Ignore Pending Update Notification',
                    value: 'False'
                }
            ],
            'POST_APPT_CONFIRM_FF': [
                {
                    name: 'disable_oor_check',
                    type: 'LIT',
                    notes: 'Disable Out Of Range Check',
                    value: 'False'
                },
                {
                    name: 'disable_transit_check',
                    type: 'LIT',
                    notes: 'Disable Transit Check',
                    value: 'False'
                }
            ],
            'LOC_MAPPING_RULES': []
        }
        return defaults[configType] || []
    }

    const normalizeRuleType = (rule) => {
        // Handle old 'always' type and convert to 'LIT'
        if (rule.type === 'always') {
            return { ...rule, type: 'LIT' }
        }
        return rule
    }

    const loadConfigData = async (configType) => {
        setLoading(true)
        setParseError(false)
        try {
            const data = await get(`crs/customisation?feature=customisation&customisation_type=${configType}`)

            if (data && data.length > 0) {
                let configJson = data[0].config
                setRawConfigData(data[0]) // Store raw response

                if (typeof configJson === 'string') {
                    configJson = JSON.parse(configJson)
                }

                // Handle LOC_MAPPING_RULES differently - it uses auto_map_loc_ctx_v1 structure
                if (configType === 'LOC_MAPPING_RULES') {
                    setConfigData({
                        auto_map_loc_ctx_v1: configJson.auto_map_loc_ctx_v1 || []
                    })
                } else if (configJson && configJson.vars) {
                    try {
                        // Normalize existing vars and use them directly
                        const normalizedVars = configJson.vars.map(normalizeRuleType)

                        // Always show both variables: existing from DB + missing defaults
                        const defaultVars = getDefaultVarsForConfigType(configType)

                        const finalVars = [...normalizedVars]

                        // Add any missing default vars
                        defaultVars.forEach(defaultVar => {
                            if (!finalVars.find(v => v.name === defaultVar.name)) {
                                finalVars.push(defaultVar)
                            }
                        })

                        setConfigData({
                            ...configJson,
                            vars: finalVars
                        })
                    } catch (parseErr) {
                        console.warn('Parse error in vars, falling back to defaults:', parseErr)
                        setParseError(true)
                        setConfigData({
                            vars: getDefaultVarsForConfigType(configType)
                        })
                    }
                } else {
                    // No vars found, use defaults based on config type
                    if (configType === 'LOC_MAPPING_RULES') {
                        setConfigData({
                            auto_map_loc_ctx_v1: []
                        })
                    } else {
                        setConfigData({
                            vars: getDefaultVarsForConfigType(configType)
                        })
                    }
                }
            } else {
                setRawConfigData(null)
                if (configType === 'LOC_MAPPING_RULES') {
                    setConfigData({
                        auto_map_loc_ctx_v1: []
                    })
                } else {
                    setConfigData({
                        vars: getDefaultVarsForConfigType(configType)
                    })
                }
            }
            setLoading(false)
        } catch (error) {
            console.error('Load config data error:', error);
            setParseError(true)
            if (configType === 'LOC_MAPPING_RULES') {
                setConfigData({
                    auto_map_loc_ctx_v1: []
                })
            } else {
                setConfigData({
                    vars: getDefaultVarsForConfigType(configType)
                })
            }
            setLoading(false)
        }
    }

    const updateConfigData = async (configType, updatedConfig) => {
        setLoading(true)
        try {
            const payload = {
                customisation_type: configType,
                config: updatedConfig
            }

            const savedData = await put(`crs/customisation?feature=customisation`, payload)

            await loadConfigData(configType)

            const response = {
                message: 'Configuration updated successfully',
                data: savedData
            }
            setUpdateResponse(response)
            setLoading(false)
            setSuccess(true)
        } catch (error) {
            console.error('Update config error:', error);
            setLoading(false)
            setError(true)
        }
    }

    const convertRulesToExpression = (rules) => {
        try {
          if (!rules || (!rules.true_conditions && !rules.false_conditions)) return 'False'
        
          const trueConditions = []
          const falseConditions = []
        
          if (rules.true_conditions?.any) {
            rules.true_conditions.any.forEach(anyGroup => {
              if (anyGroup.all && anyGroup.all.length > 0) {
                const andConditions = anyGroup.all.map(condition => {
                  const fieldName = condition.field

                  if (condition.op === 'in') {
                    let values = condition.value
                    if (typeof values === 'string') {
                        values = values.split(',').map(v => v.trim()).filter(v => v !== '')
                    } else if (!Array.isArray(values)) {
                        values = [values]
                    }
                    const shouldLowercase = fieldName.includes('.lower()')
                    const valueStr = values.map(v => shouldLowercase ? `'${v.toLowerCase()}'` : `'${v}'`).join(', ')
                    return `${fieldName} in [${valueStr}]`
                  }

                  if (condition.op === '=ignore_case') {
                    // Use null-safe syntax (field || "").lower() for ignore case
                    const baseFieldName = fieldName.replace(/\.lower\(\).*$/, '')
                    return `(${baseFieldName} or "").lower() == '${condition.value.toLowerCase()}'`
                  }

                  const pythonOp = condition.op === '=' ? '==' : condition.op
                  // For regular equals, use field as-is without .lower()
                  const actualFieldName = condition.op === '=' ? fieldName.replace(/\.lower\(\).*$/, '') : fieldName
                  const shouldLowercase = fieldName.includes('.lower()') && condition.op !== '='
                  return `${actualFieldName} ${pythonOp} ${shouldLowercase ? `'${condition.value.toLowerCase()}'` : `'${condition.value}'`}`
                })

                trueConditions.push(andConditions.length > 1 ? 
                  `(${andConditions.join(' and ')})` : andConditions[0])
              }
            })
          }

          if (rules.false_conditions?.any) {
            rules.false_conditions.any.forEach(anyGroup => {
              if (anyGroup.all && anyGroup.all.length > 0) {
                const andConditions = anyGroup.all.map(condition => {
                  const fieldName = condition.field

                  if (condition.op === 'in') {
                    let values = condition.value
                    if (typeof values === 'string') {
                        values = values.split(',').map(v => v.trim()).filter(v => v !== '')
                    } else if (!Array.isArray(values)) {
                        values = [values]
                    }
                    const shouldLowercase = fieldName.includes('.lower()')
                    const valueStr = values.map(v => shouldLowercase ? `'${v.toLowerCase()}'` : `'${v}'`).join(', ')
                    return `${fieldName} in [${valueStr}]`
                  }

                  if (condition.op === '=ignore_case') {
                    // Use null-safe syntax (field || "").lower() for ignore case
                    const baseFieldName = fieldName.replace(/\.lower\(\).*$/, '')
                    return `(${baseFieldName} or "").lower() == '${condition.value.toLowerCase()}'`
                  }

                  const pythonOp = condition.op === '=' ? '==' : condition.op
                  // For regular equals, use field as-is without .lower()
                  const actualFieldName = condition.op === '=' ? fieldName.replace(/\.lower\(\).*$/, '') : fieldName
                  const shouldLowercase = fieldName.includes('.lower()') && condition.op !== '='
                  return `${actualFieldName} ${pythonOp} ${shouldLowercase ? `'${condition.value.toLowerCase()}'` : `'${condition.value}'`}`
            })

                falseConditions.push(andConditions.length > 1 ? 
                  `(${andConditions.join(' and ')})` : andConditions[0])
              }
            })
          }

          if (trueConditions.length === 0 && falseConditions.length === 0) {
            return 'False'
          }

          if (trueConditions.length > 0 && falseConditions.length === 0) {
            const conditionStr = trueConditions.join(' or ')
            return `True if ${conditionStr} else False`
          }

          if (trueConditions.length === 0 && falseConditions.length > 0) {
            const conditionStr = falseConditions.join(' or ')
            return `False if ${conditionStr} else True`
          }

          const trueStr = trueConditions.join(' or ')
          const falseStr = falseConditions.join(' or ')
          return `True if ${trueStr} else (False if ${falseStr} else ${rules.default || 'False'})`

        } catch (error) {
          console.error('Convert rules error:', error)
          return ''
        }
    }

    const valueToShare = {
        loading, setLoading,
        success, setSuccess,
        error, setError,
        // configTypes, setConfigTypes,
        configData, setConfigData,
        rawConfigData, setRawConfigData,
        parseError, setParseError,
        // loadConfigTypes,
        loadConfigData,
        updateConfigData,
        updateResponse,
        getConfigMetadata,
        getFieldMappings,
        getFieldOptions,
        getOperatorsForField,
        convertRulesToExpression,
        getDefaultVarsForConfigType,
        normalizeRuleType
    }

    return (
        <ConfigContext.Provider value={valueToShare}>
            {children}
        </ConfigContext.Provider>
    )
}

export { Provider }
export default ConfigContext
